import { color } from "@styles";
import { NewProductIntro } from "components/atoms/NewProductIntro";
import { Text, types } from "react-bricks/frontend";
import { getVerticalPadding, VerticalPadding, verticalPadSideProp } from "../utils/verticalPadding";

interface IntroductionBlockProps {
  showEyebrow?: boolean;
  backgroundColor: types.IColor;
  titleColor: types.IColor;
  eyebrowColor?: types.IColor;
  maxWidth?: string;
  paddingVertical?: VerticalPadding;
}

const IntroductionBlock: types.Brick<IntroductionBlockProps> = ({
  backgroundColor,
  titleColor,
  eyebrowColor,
  maxWidth,
  paddingVertical,
  showEyebrow,
}) => {
  const pad = getVerticalPadding(paddingVertical);

  const title = (
    <Text
      propName="title"
      placeholder="Type a title..."
      renderBlock={({ children }) => <span>{children}</span>}
    />
  );

  const eyebrow = showEyebrow ? (
    <Text
      propName="eyebrow"
      placeholder="Type a eyebrow..."
      renderBlock={({ children }) => <span>{children}</span>}
      renderPlaceholder={() => <></>}
    />
  ) : null;

  return (
    <NewProductIntro
      title={title}
      eyebrow={eyebrow}
      backgroundColor={backgroundColor?.color}
      titleColor={titleColor?.color}
      eyebrowColor={eyebrowColor?.color}
      maxWidth={maxWidth}
      pt={pad}
      pb={pad}
    />
  );
};

IntroductionBlock.schema = {
  name: "introduction-block",
  label: "Introduction Block",
  category: "content sections",
  previewImageUrl: "/static/bricks/introduction-block.png",
  getDefaultProps: () => ({
    title: "Insurance has the potential to act as a powerful force for good",
    backgroundColor: { color: color.P100 },
    titleColor: { color: color.white },
    maxWidth: "50rem",
    paddingVertical: "m",
  }),
  sideEditProps: [
    {
      name: "backgroundColor",
      label: "Background Color",
      type: types.SideEditPropType.Select,
      shouldRefreshStyles: true,
      selectOptions: {
        display: types.OptionsDisplay.Color,
        options: [
          { value: { color: color.P100 }, label: "Purple" },
          { value: { color: color.S3100 }, label: "Dark Blue" },
          { value: { color: color.S410 }, label: "Light Blue" },
          { value: { color: color.white }, label: "White" },
        ],
      },
    },
    {
      name: "titleColor",
      label: "Title Color",
      type: types.SideEditPropType.Select,
      shouldRefreshStyles: true,
      selectOptions: {
        display: types.OptionsDisplay.Color,
        options: [
          { value: { color: color.white }, label: "White" },
          { value: { color: color.B1100 }, label: "Black" },
          { value: { color: color.P100 }, label: "Purple" },
        ],
      },
    },
    {
      name: "showEyebrow",
      label: "Show eyebrow?",
      type: types.SideEditPropType.Boolean,
    },
    {
      name: "eyebrowColor",
      label: "Eyebrow Color",
      type: types.SideEditPropType.Select,
      shouldRefreshStyles: true,
      show: (props) => props.showEyebrow,
      selectOptions: {
        display: types.OptionsDisplay.Color,
        options: [
          { value: { color: color.white }, label: "White" },
          { value: { color: color.B1100 }, label: "Black" },
          { value: { color: color.P100 }, label: "Purple" },
        ],
      },
    },
    verticalPadSideProp,
  ],
};

export default IntroductionBlock;
